import { render, staticRenderFns } from "./BrandModal.vue?vue&type=template&id=dc16ce66&"
import script from "./BrandModal.vue?vue&type=script&lang=js&"
export * from "./BrandModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports